import {FlyerPages, IFlyerPagesRef} from './flyerPages/FlyerPages'

import './FlyerEditorContent.scss'
import {FlyerDto, SelectPageForTabsDto} from '../../../../dtos'
import {useEffect, useRef, useState} from 'react'
import {useTypedSelector} from "../../../../hooks/useTypeSelector";
import {
    EVENT_TYPE_PAGE_INDEX_CHANGED,

    dispatchEventType

} from '../../../../globals/EventDispatcher'

interface IFlyerEditorContent {
    data?: FlyerDto;
}

export const FlyerEditorContent: React.FC<IFlyerEditorContent> = (props) => {
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);

    const flyerPagesRef = useRef<IFlyerPagesRef>(null)
    const [isDisabledZoom, setZoomStatus] = useState<boolean>(true);

    const [pageIndex, setPageIndex] = useState(1);
    const onPageIndexChanges = (index: number) => {
        changePageIndexState(index)
    }

    useEffect(() => {
        changePageIndexState(selectedPageState.pageNo === 0 ? 0 : selectedPageState.pageNo - 1);
        setZoomStatus(true);
    }, [selectedPageState.pageNo]);

    // 
    const changePageIndexState = (index: number) => {
        setPageIndex(index)
        dispatchEventType(EVENT_TYPE_PAGE_INDEX_CHANGED)
    }

    return (
        <>
            <div className="flyer_spots_editor_content">

                {/*<TopBar*/}
                {/*    ref={topBarReference}*/}
                {/*    total={props.data?.flyerPages?.length!}*/}
                {/*    onPageIndexChanges={onPageIndexChanges}*/}
                {/*    pageIndex={pageIndex}*/}
                {/*    leftChildren={(*/}
                {/*        <SpotsTopBarControls*/}
                {/*            showNewSpotControls={(value: boolean) => flyerPagesRef.current?.showSotsSizeSelectorGrid(value)}*/}
                {/*        />*/}
                {/*    )}*/}
                {/*    rightChildren={(*/}
                {/*        <FlyerPageControls*/}
                {/*            // selectAllPageSpots={(value: boolean) => flyerPageRef.current!.selectAllPageSpots(value)}*/}
                {/*            // deleteAllPageSpots={() => flyerPageRef.current!.deleteAllPageSpots()}*/}
                {/*            zoomIn={zoomIn}*/}
                {/*            zoomOut={zoomOut}*/}
                {/*            pageIndex={pageIndex}*/}
                {/*            resetTransform={resetTransform}*/}
                {/*            setZoomStatus={setZoomStatus}*/}
                {/*        />*/}

                {/*    )}*/}
                {/*/>*/}

                <FlyerPages
                    ref={flyerPagesRef}
                    flyerPagesRef={flyerPagesRef}
                    data={props.data}
                    pageIndex={pageIndex}
                    // onLeftArrowClick={() => topBarReference.current!.showBack()}
                    // onNextArrowClick={() => topBarReference.current!.showNext()}
                    isDisabledZoom={isDisabledZoom}
                    total={props.data?.flyerPages?.length!}
                    setZoomStatus={setZoomStatus}
                    onPageIndexChanges={onPageIndexChanges}

                />

            </div>
        </>
    )
}